import { gql } from '@apollo/client/core';

export const migrateShiftTurnoverNotes = gql`
  mutation migrateShiftTurnoverNotes($shiftTurnoverId: String) {
    migrateShiftTurnoverNotes(shiftTurnoverId: $shiftTurnoverId) {
      value
    }
  }
`;
